import { MeetingsAPI } from 'api'

export const fetchAssistantAgentSettings = () => {
  return MeetingsAPI.get('/assistant/settings/agent').then(
    (response) => response.data
  )
}

export const patchAssistantAgentSettings = (assistantAgentSettings) => {
  return MeetingsAPI.patch('/assistant/settings/agent', {
    taskConfigMap: assistantAgentSettings,
  }).then((response) => response.data)
}
